import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    margin: '0 auto',
    padding: theme.spacing(1.5, 2),
  },

  container: {
    maxWidth: 1280,
  },
}));
